import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// Define the initial state of the form
const initialState = {
    chats: [],
    status: 'idle', // 'idle' | 'loading' | 'success' | 'failed'
    error: null
};

// Async thunk for fetching the live shopping form data
export const fetchChats = createAsyncThunk(
    'data/fetchChats',
    async ({liveShoppingId, customFetch}, { rejectWithValue }) => {
        try {
            // Replace with your API endpoint
            const response = await customFetch(`/api/chats/${liveShoppingId}`);
            if (!response.ok) {
                throw new Error('Failed to fetch chat data');
            }
            return await response.json();
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

// The slice for the form
const chatSlice = createSlice({
    name: 'chat',
    initialState,
    reducers: {
        // Reducer to update form data and validate fields
        addChats: (state, action) => {
            console.log('addChats', action)
            state.chats = [...state.chats, action.payload?.chat];
        },
        updateChats: (state, action) => {
            console.log('updateChats', action.payload)
            let chatIndex = state.chats.findIndex(({messageId}) => messageId === action.payload?.messageId)
            state.chats[chatIndex] = {...state.chats[chatIndex], ...action.payload?.data}
        },
        addReactions: (state, action) => {
            console.log('addReactions', action)
            let userId = action.payload.reaction?.userIds[0];
            state.chats = state.chats.map(chat => {
                if (chat.messageId == action.payload?.messageId) {
                    if(chat.reactions?.length) {
                        let previous_index = chat.reactions.findIndex(reaction => reaction?.userIds?.includes(userId))
                        if(previous_index >= 0){
                            chat.reactions[previous_index]['userIds'].splice(chat.reactions[previous_index]['userIds'].indexOf(userId), 1)
                        }
                        let index = chat.reactions.findIndex(reaction => reaction.unified === action.payload.reaction?.unified)
                        if(index >=0){
                            chat.reactions[index]['userIds'].push(userId)
                        }
                        else chat.reactions.push(action.payload?.reaction)
                    }
                    else
                        chat.reactions = [action.payload?.reaction]
                }
                return chat
            })
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchChats.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchChats.fulfilled, (state, action) => {
                console.log('action.payload.data',action.payload.data)
                state.status = 'success';
                state.chats = action.payload.data;
            })
            .addCase(fetchChats.rejected, (state, action) => {
                state.status = `failed,${action.payload}`;
                state.error = action.payload;
            });
    }
});

export const { addChats, addReactions, updateChats } = chatSlice.actions;
export default chatSlice.reducer
